import _isEqual from 'lodash/isEqual'
import { useRouter } from 'next/router'
import { memo } from 'react'

import type { Color } from '@nxt-insurance/ui-kit/types'

import { runQuery } from '@/cms/client'
import { siteSettingsQueryFooter, siteSettingsQuerySecondaryFooter } from '@/cms/pages'
import type { Route } from '@/cms/pages'
import { SectionsRenderer } from '@/components/renderers/Sections'
import { getLocaleParts } from '@/utils/locale'
import { getContrastColor } from '@/utils/style'
import { useQuery } from '@tanstack/react-query'

export const Footer = memo((props: { footerColor?: Color; pageType?: Route['pageType'] }) => {
  const { locale } = useRouter()
  const [lang, market] = getLocaleParts(locale)
  const { data } = useQuery({
    queryKey: ['footer', lang, market],
    queryFn: async () =>
      Promise.all([
        runQuery(siteSettingsQueryFooter, { lang, market }),
        runQuery(siteSettingsQuerySecondaryFooter, { lang, market }),
      ]),
    throwOnError: true,
  })
  if (!data) {
    return null
  }
  const [{ footer }, { secondaryFooter }] = data
  if (!props.pageType) {
    return <SectionsRenderer sections={footer} />
  } else if (props.pageType._type !== 'website.pageType.noHeaderNoFooter') {
    return (
      <>
        <SectionsRenderer
          sections={footer}
          backgroundColor={props.footerColor ?? undefined}
          contentColor={props.footerColor ? getContrastColor(props.footerColor) : undefined}
        />

        {secondaryFooter ? (
          <SectionsRenderer
            sections={secondaryFooter}
            backgroundColor={
              props.footerColor && props.footerColor !== 'uiGreyLight'
                ? (props.footerColor?.replace('Light', 'Dark') as Color)
                : 'uiGreyDark'
            }
            contentColor="uiLight"
          />
        ) : null}
      </>
    )
  }
  return null
}, _isEqual)
